<div class="content-container">
  <h2>Bewerk laadmoment #{{ task.subProject?.project?.id }}</h2>

  <mat-spinner
    *ngIf="!init"
    style="margin: auto"
    color="primary"
    diameter="24"
  ></mat-spinner>

  <div *ngIf="init">
    <div class="form-sub-title">Selecteer datum</div>

    <mat-form-field appearance="outline">
      <input
        #datePickerInput
        matInput
        [matDatepickerFilter]="filterSundays"
        [matDatepicker]="datePicker"
        placeholder="Selecteer een datum"
        [value]="date"
        (dateChange)="taskDateChange($event)"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="datePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #datePicker></mat-datepicker>
    </mat-form-field>

    <div class="form-sub-title">Selecteer installateur</div>

    <mat-form-field class="" appearance="outline">
      <mat-select
        matInput
        placeholder="Installateur"
        name="placerSelector"
        [(ngModel)]="selectedEmployee"
        [compareWith]="compareEntities"
      >
        <mat-option *ngFor="let option of employeeChoices" [value]="option">
          {{ option.user?.firstName | personName : option.user?.lastName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="form-sub-title">Tijdstip</div>

    <mat-form-field appearance="outline">
      <input
        matInput
        type="time"
        placeholder="Selecteer een tijdstip"
        [ngModel]="task.startTime"
        [ngxMatTimepicker]="startTimepicker"
        [format]="24"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="startTimeChanged($event)"
      />
      <ngx-mat-timepicker #startTimepicker></ngx-mat-timepicker>
      <!-- TODO: throws error if you use it but it works regardless, solve later -->
    </mat-form-field>

    <textarea-input
      [title]="'Omschrijving'"
      [placeholder]="'Vul hier de omschrijving in'"
      [initContent]="task.description"
      (answer)="descriptionChanged($event)"
    ></textarea-input>

    <div class="form-sub-title">Doorlooptijd</div>
    <div class="d-flex">
      <div class="timeInput">
        <div class="selector-label">Uren</div>
        <mat-form-field class="timeInput" appearance="outline">
          <mat-select
            matInput
            class="timeInputSelect"
            required
            [(ngModel)]="hourBudget"
            name="hourBudgetSelect"
            [compareWith]="compareNumbers"
          >
            <mat-option
              *ngFor="let option of hours"
              [value]="option"
              class="timeInputSelect"
            >
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="largeText">:</div>

      <div class="timeInput">
        <div class="selector-label">Minuten</div>
        <mat-form-field class="timeInput" appearance="outline">
          <mat-select
            matInput
            class="timeInputSelect"
            required
            [(ngModel)]="minuteBudget"
            name="minuteBudgetSelect"
            [compareWith]="compareNumbers"
          >
            <mat-option
              *ngFor="let option of minutes"
              [value]="option"
              class="timeInputSelect"
            >
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
<div class="confirm-container border-top">
  <mat-spinner *ngIf="saving" color="primary" diameter="18"></mat-spinner>
  <button
    *ngIf="!saving"
    type="button"
    (click)="close()"
    class="btn btn-main btn-back"
  >
    Annuleer
  </button>
  <button
    *ngIf="!saving"
    type="button"
    (click)="saveTask()"
    mat-button
    class="button"
  >
    Opslaan
  </button>
</div>
